// src/v3/GradientBG/index.tsx
import { cva } from "class-variance-authority";

// src/v3/RadialGradient/index.tsx
import { cx } from "class-variance-authority";

// src/v3/utils/hexToRgba.ts
function hexToRgba(hex, opacity) {
  const result = /^#?(?<temp3>[a-f\d]{2})(?<temp2>[a-f\d]{2})(?<temp1>[a-f\d]{2})$/i.exec(
    hex
  );
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
    a: opacity
  } : { r: 0, g: 0, b: 0, a: 0 };
}

// src/v3/RadialGradient/index.tsx
import { jsx } from "react/jsx-runtime";
var style = (shape, positionX, positionY, gradientColor, size) => ({
  backgroundImage: `radial-gradient(${shape} at ${positionX} ${positionY}, ${gradientColor} 0px, transparent ${size})`
});
function RadialGradient({
  hex = "#081C2D",
  id = "default-gradient",
  opacity = 1,
  position = [50, 50],
  shape = "ellipse",
  size = 40,
  className
}) {
  const gradientColor = hexToRgba(hex, opacity);
  const { r, g, b, a } = gradientColor;
  return /* @__PURE__ */ jsx("div", {
    className: cx(
      "ui-absolute ui-w-full ui-h-full ui-top-0 ui-left-0 ui-pointer-events-none",
      className
    ),
    "data-cy": "radialGradient_div",
    id,
    style: style(
      shape,
      `${position[0]}%`,
      `${position[1]}%`,
      `rgba(${r}, ${g}, ${b}, ${a})`,
      `${size}%`
    )
  });
}
RadialGradient.displayName = "RadialGradient";

// src/v3/GradientBG/index.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var gradientBGVar = cva("ui-relative ui-min-h-full", {
  variants: {
    background: {
      "gray-600": "ui-bg-gray-600",
      "cream-100": "ui-bg-cream-100",
      "sandstone-200": "ui-bg-sandstone-200",
      "sandstone-300": "ui-bg-sandstone-300",
      "sandstone-400": "ui-bg-sandstone-400",
      "gray-100": "ui-bg-gray-100",
      "gray-200": "ui-bg-gray-200",
      "slate-100": "ui-bg-slate-100",
      "slate-300": "ui-bg-slate-300",
      "slate-600": "ui-bg-slate-600",
      "mustard-50": "ui-bg-mustard-50"
    }
  },
  defaultVariants: {
    background: "gray-100"
  }
});
function RadialGradientBG({
  background,
  className = "",
  children,
  gradients,
  ...rest
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: gradientBGVar({ background, className }),
    "data-cy": "radialGradientBG_div",
    ...rest,
    children: [
      gradients.map(({ hex, id, ...props }) => /* @__PURE__ */ jsx2(RadialGradient, {
        hex,
        id,
        ...props
      }, `${hex}-${id}`)),
      children
    ]
  });
}
RadialGradientBG.displayName = "RadialGradientBG";
export {
  RadialGradientBG
};
//# sourceMappingURL=index.mjs.map